import { useState, useEffect } from "react"

export function ClientOnly({ children }: React.PropsWithChildren) {
  const [clientHydrated, setClientHydrated] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setClientHydrated(true)
  }, [])

  if (!clientHydrated) {
    return null
  }

  return <>{children}</>
}
